module.exports = __webpack_public_path__ + "img/check-square.c42928f2.svg";